module.exports = __webpack_public_path__ + "img/9_127.de5a5f1b.png";